import { Bounds } from "@animech/camera";
import { Vec3 } from "playcanvas";
import { CameraSettings } from "src/common";

/**
 * Creates bounds that keeps the camera position within the
 * min- and max limits specified in the settings.
 * Rotation and distance may be modified in order to keep
 * the camera looking at {orbitCenter} while being within the valid volume.
 */
export function positionBounds(
	orbitCenter: Vec3,
	settings: CameraSettings,
	clampThreshold = 1e-6,
): Bounds {
	const position = new Vec3();

	return function (view) {
		const { minX, minY, minZ, maxX, maxY, maxZ } = settings;
		position.copy(view.position);

		if (minX !== undefined) {
			position.x = Math.max(position.x, minX);
		}
		if (maxX !== undefined) {
			position.x = Math.min(position.x, maxX);
		}
		if (minY !== undefined) {
			position.y = Math.max(position.y, minY);
		}
		if (maxY !== undefined) {
			position.y = Math.min(position.y, maxY);
		}
		if (minZ !== undefined) {
			position.z = Math.max(position.z, minZ);
		}
		if (maxZ !== undefined) {
			position.z = Math.min(position.z, maxZ);
		}

		return position.distance(view.position) > clampThreshold
			? view.setPosition(position).lookAt(orbitCenter)
			: view;
	};
}
